import { cn } from '@mint-lib/tw-utils';

import { useIllustration, type IllustrationsList } from './index.js';

const Illustration = ({
  component,
  className,
  ...props
}: {
  component: IllustrationsList;
  className?: string;

  props?: React.SVGProps<SVGSVGElement>;
}) => {
  const { component: Illustration } = useIllustration(component);
  return <Illustration className={cn('size-full', className)} {...props} />;
};

export default Illustration;
